import { RegionType } from "graphql/generated";

export const MINIMUM_AGE = 18;
export const MAXIMUM_AGE = 99;

export const FORMAT_BY_REGION = {
  DD: { name: "day", maxLength: 2, placeholder: "DOB_input.day_placeholder", w: "80px" },
  MM: { name: "month", maxLength: 2, placeholder: "DOB_input.month_placeholder", w: "80px" },
  YYYY: { name: "year", maxLength: 4, placeholder: "DOB_input.year_placeholder", w: "120px" }
};

export const COUNTRY_DATE_FORMATS = {
  [RegionType.Sg]: {
    format: [
      { name: "DD", nextField: "month" },
      { name: "MM", nextField: "year" },
      { name: "YYYY", nextField: null }
    ]
  },
  [RegionType.Hk]: {
    format: [
      { name: "DD", nextField: "month" },
      { name: "MM", nextField: "year" },
      { name: "YYYY", nextField: null }
    ]
  },
  [RegionType.Jp]: {
    format: [
      { name: "YYYY", nextField: "month" },
      { name: "MM", nextField: "day" },
      { name: "DD", nextField: null }
    ]
  }
};
